import { render, staticRenderFns } from "./assist_kpi.vue?vue&type=template&id=dcc41046&scoped=true"
import script from "./assist_kpi.vue?vue&type=script&lang=js"
export * from "./assist_kpi.vue?vue&type=script&lang=js"
import style0 from "./assist_kpi.vue?vue&type=style&index=0&id=dcc41046&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc41046",
  null
  
)

export default component.exports